module.exports = __webpack_public_path__ + "static/media/silhouette3.f555e2ff.jpeg";